import React, { Component } from "react";

import Header from "@components/Header";

class ClientStories extends Component {
    render() {
        return (
            <div id="main">
                <Header />
                <section>
                    <header className="content">
                        <h1>ClientStories</h1>
                    </header>
                </section>
            </div>
        );
    }
}

export default ClientStories;
